import { FC } from 'react';
import { Link, useParams } from 'react-router-dom';

const RequestSuccess: FC = () => {
    const { slug } = useParams<{ slug: string }>();
    
    return (
        <div className="p-4 sm:p-6 lg:p-8 text-center">
            <p className="text-xl font-medium">
                The request submitted successfully. Thank you.
            </p>
            <div className="pt-5">
                <Link
                    to={`/public/request/${slug}`}
                    target="_self"
                    className="p-2 pl-5 pr-5 bg-blue-500 text-gray-100 text-lg rounded-lg
                     focus:border-4 border-blue-300"
                >
                    Submit Another Request
                </Link>
            </div>
        </div>
    );
};

export default RequestSuccess;